import React from "react";
import { motion } from "framer-motion";
import CardValeur from "./Card_Valeur";
import "./Valeurs.css"; 

function Valeurs() {
  return (
      <div className="cards">
        <motion.h1
          className="title-h1"
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, ease: "easeOut" }}
        >
          Pourquoi Cristal Inox
        </motion.h1>
        <div className="cards__container">
          <div className="cards__wrapper">
            <ul className="cards__items">
              <CardValeur
                title={"Qualité et Durabilité"}
                className="cards__item"
                text={
                  "Nous utilisons de l'acier inoxydable haut de gamme pour garantir des réalisations solides, esthétiques et durables dans le temps."
                }
                nameClass={"bronz"}
              />
              <CardValeur
                title={"Expertise et Savoir-Faire"}
                className="cards__item"
                text={
                  "Forts d’une expérience en chaudronnerie inox, nous concevons des solutions sur-mesure adaptées aux secteurs de la décoration, du médical et de la tuyauterie."
                }
              />
              <CardValeur
                title={"Innovation et Précision"}
                className="cards__item"
                text={
                  "Nous allions design et précision technique pour offrir des produits inox qui répondent aux exigences les plus élevées, du simple élément décoratif aux installations industrielles."
                }
              />
            </ul>
          </div>
        </div>
      </div>
  );
}

export default Valeurs;
